/**
 * Helpers del envío de las credenciales del lead por email
 * (POST /ventas/accesos-email → lambda v_sendAccesosEmail).
 *
 * Puros y testeables: los modales solo los consumen.
 */

export function isValidEmail(value) {
  if (typeof value !== "string") return false;
  return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(value.trim());
}

export function buildAccesosEmailPayload({ companyId, email, contactId, nombre } = {}) {
  return {
    company_id: companyId,
    email: (email || "").trim(),
    ...(contactId ? { contact_id: contactId } : {}),
    ...(nombre ? { nombre } : {}),
  };
}

const ERROR_COPY = {
  email_invalido: "El correo no es válido. Revísalo y vuelve a intentarlo.",
  company_id_requerido: "Este lead todavía no tiene una cuenta de prueba creada.",
  accesos_no_encontrados:
    "Este lead no tiene accesos creados (o se borraron). Créalos antes de enviarlos por email.",
  email_send_failed: "No se pudo enviar el correo. Inténtalo de nuevo en un minuto.",
};

export function accesosEmailErrorMessage(err) {
  const code = err?.response?.data?.error;
  if (code && ERROR_COPY[code]) return ERROR_COPY[code];
  return err?.response?.data?.message || err?.message || "Error desconocido";
}
